import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Organisation } from 'src/app/generated/services/organisations/organisation';
import { LPGDistService, ToolbarItem } from 'src/app/lpg-dist/lpg-dist.service';
import { Router } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatButtonModule } from '@angular/material/button';
import { MaterialDateRangeComponent, DateRange} from 'src/app/shared/components/material-date-picker/material-date-range.component';
import { MaterialOrganisationSelectorComponent } from 'src/app/shared/components/material-autocomplete/material-organisationselector.component';
import { MatIconModule } from '@angular/material/icon';

interface DailyReportComponentSettings {
  companyId: string;
  calendar: boolean;
}
@Component({
  selector: 'app-lpg-dist-toolbar',
  templateUrl: './lpg-dist-toolbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[
    SharedModule,
    MaterialDateRangeComponent,
    MatButtonModule,
    MaterialOrganisationSelectorComponent,
    MatIconModule
  ]
})

export class LpgDistToolbarComponent {

  @Output()
    itemsSelected: EventEmitter<ToolbarItem> = new EventEmitter<ToolbarItem>();

  @Output()
    download: EventEmitter<boolean> = new EventEmitter<boolean>();

  visibleOrganisation = false;
  organisations: Organisation[] = [];
  dateRange: DateRange = {
    startDate: new Date(),
    endDate: new Date()
  };
  language?: string;
  singleDate: boolean = false;
  selectedOrganisation: Organisation = Organisation.create();
  toolbarItem?: ToolbarItem;
  jalali: boolean = false;
  visibleButton = false;

  _settings?: DailyReportComponentSettings;
  startDate: Date = new Date();
  endDate: Date = new Date();
  endOfMonth: Date = new Date();

  excelExport?: (service: LPGDistService, dateRange: DateRange, organisationId?: string) => void;

  constructor(
    private _router: Router,
    private _lpgDistService: LPGDistService) { }

  onSubmit() {
    this.toolbarItem = {
      dateRange: this.dateRange,
      companyId: (this.selectedOrganisation) ? this.selectedOrganisation.name : undefined,
      selectedCalander: this.jalali
    };
    this.itemsSelected.emit(this.toolbarItem);
  }

  changeDate(newDate: DateRange) {
    if (newDate) {
      this.onSubmit();
    }
  }

  changeOrganisation(org: Organisation){
    if (org){
      this.onSubmit();
    }
  }

  lpgDistQuotaDataEntry(): void {
    this._router.navigate(['lpg-dist/quta-entry']);
  }

  xlsxReport() {
    const name = (this.selectedOrganisation) ? this.selectedOrganisation.name : '';
    if(this.excelExport) {
      this.excelExport(this._lpgDistService, this.dateRange, name);
    }
  }
}
